import React from 'react';

const ConfirmModal = (props: any) => {
  const { title, children, btn_actions, active, refs, style = {}, overlayStyle = {} } = props;
  const confirm_btn = btn_actions && btn_actions.confirm_btn;
  const cancel_btn = btn_actions && btn_actions.cancel_btn;
  return (
    <div>
      <div ref={refs} style={style} className={`confirm_modal ${active ? 'active' : ''}`}>
        <div className="confirm_modal_header">
          <span>{title || 'Please confirm the action'}</span>
        </div>

        <div className="confirm_modal_body">{children}</div>

        <div className="confirm_modal_actions">
          <div className="confirm_modal_actions_btn">
            <button
              disabled={(cancel_btn && cancel_btn.disabled) || false}
              className="cancel_btn"
              onClick={() => (cancel_btn && cancel_btn.action()) || {}}
              type="button"
            >
              {(cancel_btn && cancel_btn.title) || 'No'}
            </button>
          </div>

          <div className="confirm_modal_actions_btn">
            <button
              disabled={(confirm_btn && confirm_btn.disabled) || false}
              className="confirm_btn"
              onClick={() => (confirm_btn && confirm_btn.action()) || {}}
              type="button"
            >
              {(confirm_btn && confirm_btn.title) || 'Yes'}
            </button>
          </div>
        </div>
      </div>

      <div
        style={overlayStyle}
        onClick={() => (cancel_btn && cancel_btn.action()) || {}}
        className={`confirm_modal_overlay ${active ? 'active' : ''}`}
      />
    </div>
  );
};

export default ConfirmModal;
